import { APIProvider } from '@vis.gl/react-google-maps';
import { AuctionsNearMeAuctionHouseCount } from './components/GoogleMap/AuctionsNearMeAuctionHouseCount';
import { AuctionsNearMeGoogleMap, MapBounds } from './components/GoogleMap/AuctionsNearMeGoogleMap';
import { AuctionsNearMeSearchInput } from './components/SearchInput/AuctionsNearMeSearchInput';
import { CatalogNearMe } from '@/redux/modules/auctionsNearMe/catalogsNearMe.types';
import { GeoArea } from '@/types/GeoArea';
import { getGoogleApiKey } from '@/redux/modules/config';
import { useAppSelector } from '@/redux/hooks';

type Props = {
    catalogsNearMe: CatalogNearMe[];
    geoArea: GeoArea;
    isGeocoding: boolean;
    mapBounds: MapBounds;
    onBoundsChange: (bounds: MapBounds) => void;
    onGoogleMapsReady: () => void;
    onSearchResults: (bounds: MapBounds) => void;
    parentSearchTerm: string;
    setGeocoderFailed: (failed: boolean) => void;
    setSearchTerm: (term: string) => void;
};

export const AuctionsNearMeMapViewNew = ({
    catalogsNearMe,
    geoArea,
    isGeocoding,
    mapBounds,
    onBoundsChange,
    onGoogleMapsReady,
    onSearchResults,
    parentSearchTerm,
    setGeocoderFailed,
    setSearchTerm,
}: Props) => {
    const googleApiKey = useAppSelector(getGoogleApiKey);

    return (
        <>
            <div className="mb-xs mt-lg smMin:mb-sm smMin:mt-0">
                <AuctionsNearMeAuctionHouseCount catalogsNearMe={catalogsNearMe} />
            </div>
            <APIProvider apiKey={googleApiKey}>
                <AuctionsNearMeSearchInput
                    currentGeoArea={geoArea}
                    onSearchResults={onSearchResults}
                    parentSearchTerm={parentSearchTerm}
                    setGeocoderFailed={setGeocoderFailed}
                    setPageTitleSearchTerm={setSearchTerm}
                />
                <AuctionsNearMeGoogleMap
                    bounds={mapBounds}
                    catalogs={catalogsNearMe}
                    isGeocoding={isGeocoding}
                    onBoundsChange={onBoundsChange}
                    onLoad={onGoogleMapsReady}
                />
            </APIProvider>
        </>
    );
};
